/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BankApi } from '../api/bank.api';
import { switchMap, map } from 'rxjs/operators';
import { BankData, Bank } from '../../../interfaces/masters/bank';

@Injectable()
export class BankService extends BankData {

  constructor(private api: BankApi) {
    super();
  }


  list(url: string): Observable<Bank[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Bank>{
      return this.api.getById(url);
  }

  create(url: string, data:Bank): Observable<Bank> {
    return this.api.add(url,data);
  }

  update(url: string, data:Bank): Observable<Bank> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
